import { indexToIdList } from '@/lib/view-sort';
import { intersection } from 'lodash-es';
import { validationError } from 'shared/constants.json';

export default function useDragActionValidator(parentValidator, goalSelector, goalTree) {
  const violatesRule = (parentId, toRealignIds) => {
    const parent = goalSelector.selectSingle(parentId);
    const toRealign = goalSelector.selectMultiple(toRealignIds);
    if (parent === undefined) {
      return true;
    }

    if (toRealign.length !== toRealignIds.length) {
      return true;
    }

    for (let i = 0; i < toRealign.length; i++) {
      const errs = parentValidator.validate({ toValidate: parent, selectRulesFrom: toRealign[i] });
      if (Object.keys(errs).length > 0) {
        return true;
      }
    }

    return false;
  };

  const isValid = (operation) => {
    if (operation.newParentId === null || operation.newParentId === 0) {
      return { isValid: true };
    }

    const dropOverParents = goalTree.value.filter((g) => g.entity.uid === operation.newParentId);
    if (dropOverParents.length === 0) {
      return { isValid: false, message: 'new parents are not in goal tree' };
    }

    for (let i = 0; i < dropOverParents.length; i++) {
      const parentChain = indexToIdList(dropOverParents[i].index);
      if (intersection(operation.toMoveIds, parentChain).length > 0) {
        return { isValid: false, message: validationError.circularReferenceNotAllowed };
      }
    }

    if (violatesRule(operation.newParentId, operation.toRealignIds)) {
      return { isValid: false, message: 'violates rule' };
    }

    return { isValid: true };
  };

  return { isValid };
}
